import http from "../../shared/http"
import Vue from "vue"
import _ from "lodash"

const config = {
    state: {
        config: null,
        userConfig: null
    },
    actions: {
        fetchConfig({commit}, path) {
            return new Promise((resolve, reject) => {
                http.post("/v1/config/get", path)
                .then((resp) => {
                    commit('SET_CONFIG', resp.data)
                    resolve(resp.data)
                }).catch((err) => {
                    reject(err)
                })
            })
        },
        fetchConfigs({commit}) {
            return new Promise((resolve, reject) => {
                http.get("/v1/config/")
                .then((resp) => {
                    commit('SET_CONFIGS', resp.data)
                    resolve()
                }).catch((err) => {
                    reject()
                })
            })
        },
        fetchUserConfigs({commit, state}) {
            return new Promise((resolve, reject) => {
                if (state.userConfig) {
                    resolve(state.userConfig)
                    return
                }

                http.get("/v1/config/user")
                .then((resp) => {
                    commit('SET_USER_CONFIGS', resp.data || [])
                    resolve(resp.data)
                }).catch((err) => {
                    reject()
                })
            })
        },
        
        updateUserConfig({commit}, config) {
            return new Promise((resolve, reject) => {
                http.put("/v1/config/user", config)
                .then((resp) => {
                    commit('UPDATE_USER_CONFIG', resp.data)
                    resolve()
                }).catch((err) => {
                    reject()
                })
            })
        },
        updateProjectUserConfig({commit, getters}, config) {
            config.project_uuid = getters.getCurrentProject.uuid

            return new Promise((resolve, reject) => {
                http.put("/v1/config/user", config)
                .then((resp) => {
                    commit('UPDATE_USER_CONFIG', resp.data)
                    resolve()
                }).catch((err) => {
                    reject()
                })
            })
        }
    },
    mutations: {
        SET_CONFIG (state, cfg) {
            let found = state.config.findIndex((e) => {
                return e.path == cfg.path
            })

            if (found !== -1) {
                state.config[found] = config
            } else {
                state.config.push(cfg)
            }
        },

        SET_CONFIGS (state, config) {
            state.config.push(config)
        },

        SET_USER_CONFIGS (state, configs) {
            state.userConfig = configs
        },

        UPDATE_USER_CONFIG (state, cfg) {
            let found = state.userConfig.findIndex((e) => {
                return e.path == cfg.path
            })

            let userConfig = _.cloneDeep(state.userConfig)

            if (found !== -1) {
                userConfig[found] = cfg
            } else {
                userConfig.push(cfg)
            }

            Vue.set(state, "userConfig", userConfig)
        },
    },
    getters: {
        config: (state) => (path) => {
            if (path === undefined) {
                return state.config
            }

            let config = state.config || []
            let cfg = config.find((e) => {
                return e.path == path
            })

            if (cfg === undefined) {
                return state.config
            }

            return cfg

        },

        configs(state) {
            return state.config
        },

        userConfig: (state) => (path) => {
            if (path === undefined) {
                return state.userConfig
            }

            let userConfig = state.userConfig || []

            let cfgs = userConfig.filter((e) => {
                return e.path == path
            })

            return cfgs || []
        },

        projectUserConfig: (state, getters) => (path) => {
            let cfgs = getters.userConfig(path) || []

            try {
                if (getters.getCurrentProject) {
                    return cfgs.find(c => {
                        return c.project_uuid == getters.getCurrentProject.uuid && c.path == path
                    })
                }
            } catch (err) {
                console.error(err)
                
                return null
            }
        },
    }
  }

export default config
